import { render } from "./com_inventarios.vue?vue&type=template&id=f77677fa&scoped=true"
import script from "./com_inventarios.vue?vue&type=script&lang=js"
export * from "./com_inventarios.vue?vue&type=script&lang=js"

import "./com_inventarios.vue?vue&type=style&index=0&id=f77677fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77677fa"]])

export default __exports__